<template>
  <div class="screen page formActions b-soft">
    <div id="pantalla-espera" v-if="isLoading"></div>
    <div class="grid">
      <form v-on:submit.prevent="actionForm(id, cliente, 'clientes', 'form')" class="form layout">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <label for="color">Selecciona un Color</label>
              <swatches v-model="cliente.color" :colors="colors" row-length="20" popover-to="right" swatch-size="20"></swatches>
            </div>
            <div class="col-12" v-bind:class="{'filled': cliente.nombre != ''}">
              <label for="nombre">Saludo</label>
              <input id="nombre" type="text" v-model="cliente.nombre" placeholder="Escribe algo...">
            </div>
            <div class="col-12" v-bind:class="{'filled': cliente.contacto != ''}">
              <label for="contacto">Contacto</label>
              <input id="contacto" type="text" v-model="cliente.contacto" placeholder="Escribe algo...">
            </div>
            <div class="col-12" v-bind:class="{'filled': cliente.empresa != ''}">
              <label for="empresa">Cliente</label>
              <input id="empresa" type="text" v-model="cliente.empresa" placeholder="Escribe algo...">
            </div>
            <div class="col-12">
              <ul v-if="messages.length" class="messages-container">
                <li v-for="message in messages" :key="message.content" v-bind:class="['message-item t-12-px', message.type]"><i class="fas fa-times" @click.prevent.stop="delete_message(message)"></i> {{message.content}}</li>
              </ul>
            </div>
            <div class="col-12">
              <button v-if="id" type="submit" class="btn b-secondary">Guardar Cambios</button>
              <button v-if="id" v-on:click.prevent="actionForm(id, cliente, 'clientes', 'clone')" class="btn b-primary">Clonar Elemento</button>
              <button v-else type="submit" class="btn b-secondary">Crear Nuevo Elemento</button>
            </div>
          </div>
        </div>
      </form>
      <GetFooter />
    </div>
  </div>
</template>

<script>
import GetFooter from '@/components/footer.vue'
import Swatches from 'vue-swatches'
import router from '@/router'
import { getColors } from '@/colors.js'
import { db, auth } from '@/firebase'
export default {
  name: 'app',
  components: {
    GetFooter,
    Swatches
  },
  data() {
    return {
      isLoading: false,
      isEditing: false, 
      id: this.$route.params.id,
      cliente: [],
      usuario_login: [],
      messages: [],
      colors: getColors
    }
  },
  firestore () {
    return {
      usuario_login: db.collection('usuarios').doc(auth.currentUser.uid)
    }
  },
  created() {
    if(this.$route.params.id){
      db.collection('clientes').doc(this.id)
      .get()
      .then(doc => {
        if (doc.exists) {
          this.id = doc.id
          this.cliente = doc.data()
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
    }
  },
  watch: {
    cliente: {
      deep: true,
      handler(newArray, oldArray){
        if(oldArray.nombre){
          this.isEditing = true
        }else{
          this.isEditing = false
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if(this.isEditing === true){
      const answer = window.confirm('¿Estás Seguro? Se perderá la información que se haya modificado')
      if(answer){
        next()
      } else {
        next(false)
      }
    }else{
      next()
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    })
  },
  methods: {
    preventNav(event) {
      if (!this.isEditing) return
      event.preventDefault()
    },
    delete_message (value){
     this.messages.splice(this.messages.indexOf(value), 1)
    },
    actionForm (id, elemento, collection, type) {
      const id_cliente = id
      var item_nombre = elemento.nombre
      var item_color = elemento.color
      var item_creacion = new Date()
      var url = 'dashboard'

      this.messages = []

      if(!item_nombre) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario ingresar un nombre'
        }
        this.messages.push(the_message)
      }

      if(!item_color) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario seleccionar un color'
        }
        this.messages.push(the_message)
      }

      if(!elemento.contacto){
        elemento.contacto = '';
      }

      if(!this.messages.length) {
        this.isLoading = true
        this.isEditing = false
        var vm = this
        //Verificar tipo de accion
        if(type === 'clone'){
          //Clonar elemento
          if(window.confirm('¿Estás Seguro? Si no haz guardado los cambios estos se aplicarán solamente al elemento clonado.')){
            db.collection(collection).add({
              color: elemento.color,
              fecha_creacion: item_creacion,
              fecha_modificacion: item_creacion,
              nombre: elemento.nombre, 
              contacto: elemento.contacto,
              empresa: elemento.empresa,
              usuario_creador: vm.usuario_login.nombre, 
              usuario_editor: vm.usuario_login.nombre
            })
            .then(function(doc) {
              //Documento creado con exito
              vm.isLoading = false
              router.push('/clientes/', () => {})
            })
            .catch(function(error) {
              //Error al crear
              vm.isLoading = false
              vm.messages.push({type: 'fatal b-fail', content: error.message})
            })
          }
        }else if(id_cliente && type === 'form'){
          //Actualizar elemento
          db.collection(collection).doc(id_cliente).update({
            color: elemento.color,
            fecha_modificacion: item_creacion,
            nombre: elemento.nombre, 
            contacto: elemento.contacto,
            empresa: elemento.empresa,
            usuario_editor: vm.usuario_login.nombre
          })
          .then(function(doc) {
            //Se actualizo con exito el documento
            setTimeout(function(){
              vm.isLoading = false
            }, 1200)
            vm.messages.push({type: 'success b-secondary', content: 'Se han guardado los cambios'})
          })
          .catch(function(error) {
            //Error al actualizar
            vm.isLoading = false
            vm.messages.push({type: 'fatal b-fail', content: error.message})
          })
        }else if(!id_cliente && type === 'form'){
          //Crear elemento
          db.collection(collection).add({
            color: elemento.color,
            fecha_creacion: item_creacion,
            fecha_modificacion: item_creacion,
            nombre: elemento.nombre, 
            contacto: elemento.contacto,
            empresa: elemento.empresa,
            usuario_creador: vm.usuario_login.nombre, 
            usuario_editor: vm.usuario_login.nombre
          })
          .then(function(doc) {
            //Documento creado con exito
            vm.isLoading = false
            router.push('/clientes/', () => {})
          })
          .catch(function(error) {
            //Error al crear
            vm.isLoading = false
            vm.messages.push({type: 'fatal b-fail', content: error.message})
          })
        }
      }
    }
  },
}
</script>
<style src='vue-swatches/dist/vue-swatches.min.css'></style>